
<template>
  <v-dialog max-width="600px" v-model="showDialog">
    <v-btn
      flat fab slot="activator" style="margin-top:-20px"
      class="indigo accent-1" light small mt-4 absolute middle right
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-card>
      <v-card-title>
        <h2>Define a new cemetery</h2>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-layout mx-3 my-3 column>
            <v-flex xs6 offset-xs0>
              <v-layout row>
                <v-flex xs6>
                  <v-text-field  v-if="showDialog" autofocus v-model="newCemetery.name"
                    name="cemeteryName" label="Cemetery Name"
                    :rules="[rules.required, rules.min]"/>
                </v-flex>
              </v-layout>
              <v-flex xs12 my-3 py-3>        
                <v-autocomplete v-model="place.select" :items="place.places" item-text="pn" item-value="id" label="Search for the location of this cemetery"
                  :search-input.sync="placeSearch" :loading="place.loading" single-line return-object @change="placeChange()">     
                </v-autocomplete>                        

              </v-flex>
              <provenance-and-note v-bind:record="newCemetery"/>
 
              <v-layout row>
                <v-flex xs12>
                  <div class="error" v-html="error"></div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12>
                  <v-btn dark class="indigo darken-1" :loading="loading" @click="createCemetery">
                    <v-icon left>save_alt</v-icon>Define New Cemetery
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>        

<script>
import Panel from "@/components/Panel" ;
import CemeteryService from "@/services/CemeteryService" ;
import PlaceService from "@/services/PlaceService" ;

export default {
  components: { Panel },
  data () {
    return {
      newCemetery: {
        name: "",
        placeId: -1,
        provenance: "",
        note: ""
      },
      error: null,
      message: null,
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Minimum of 8 characters is required."
      },
      loading: false,
      showDialog: false,

      place: {  
        name: '',        
        select: {id: -1, pn: ""},
        places: [],
        loading: false,        
        provenance: '',
        note: '',
        pendingSearch: null
      },
      placeSearch: null 
    };
  },

  watch: {
    async placeSearch (val) {
      if (val && val !== this.place.select.pn && (val.length >= 2)) {
        this.runPlaceSearch(val, this.place) ;
      }
    }  
  }, 

  methods: {
    async placeChange () {
      console.log("---------------------------------C: " + JSON.stringify(this.place.select)) ;
      this.newCemetery.placeId = this.place.select.id ;
    },

    async runPlaceSearch (val, locp) {

      console.log("runPlaceSearch val: " + val) ;
      if (locp.loading) {
        locp.pendingSearch = val ;
        console.log("PENDING SEARCH QUEUED: " + val) ;
        return ;
      }
      locp.loading = true ;
      try {
        const response = await PlaceService.placeFindMatchesOnName(val, true) ;
        console.log("PlaceService responsed") ; // + JSON.stringify(response)) ;

        locp.places = response.data ;
      }
      catch (err) {
        console.log("placeQuerySelections catch err:" + JSON.stringify(err)) ;
        this.error = err.response.data.error  ;
      }
      finally {
        locp.loading = false ;
        if (locp.pendingSearch) {
          const queuedSearch = locp.pendingSearch ;
          locp.pendingSearch = null ;
          console.log("Queuing pending search.." + queuedSearch) ;
          this.runPlaceSearch(queuedSearch, locp) ;
        }
      }
    },

    async createCemetery () {
      console.log("IN createCemetery");
      if (!this.$refs.form.validate()) return ;
      if (this.newCemetery.placeId <= 0) {
        this.error = "Please select the location of this cemetery" ;
        return ;
      }

      this.error = null ;
      try {
        this.loading = true ;
        const response = await CemeteryService.create(this.newCemetery);
        console.log("createCemetery response: " + response);
        this.showDialog = false ;
        this.$renderToastInParent(this, "Cemetery " + this.newCemetery.name + " successfully created") ;
      }
      catch (err) {
        console.log("catch err:" + err);
        this.error = err.response.data.error ;
      }
      finally {
        this.loading = false ;
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CemeteryCreate.vue